<template>
  <div v-if="ndc.id === root">
    <h1 class="title current_ndc_symbol">日本十進分類法</h1>
    <h2 class="subtitle current_ndc_label">NDC 第9版</h2>
    <p><a href="https://www.jla.or.jp/committees/bunrui//tabid/789/Default.aspx" target="_blank">日本図書館協会・国立国会図書館「NDCデータ（NDC8版および9版）」</a>を閲覧するためのWebサイトです
    </p>
  </div>
  <div v-else>
    <h1 class="title current_ndc_symbol">{{notation(ndc.id)}}</h1>
    <h2 class="subtitle current_ndc_label">{{ndc.prefLabel}}</h2>
  </div>
</template>

<script>
import { notation, ROOT_NDC } from '../utils';

export default {
  name: 'NdcTitle',
  props: [
    'ndc',
  ],
  data() {
    return {
      root: ROOT_NDC,
    };
  },
  methods: {
    notation,
  },
};
</script>

<style scoped>
.current_ndc_symbol {
  font-size: 3rem;
}
.current_ndc_label {
  font-size: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/NdcTitle.vue